<template>
  <dd-modal
    title="Replace variables in your reply"
    subtitle="Please confirm how your variables should be updated when you send this message."
    @handle-close="closeModal"
  >
    <div class="confirm-reply-variables-modal__table">
      <div v-if="hasCustomerName">
        <span>
          {CustomerName}
        </span>
        <div>
          <el-input
            v-model="internalVariableReplacements.customerName"
            maxlength="100"
            placeholder="Enter customer name..."
          />
        </div>
        <circle-arrow-icon />
      </div>
      <div v-if="hasCustomerFirstName">
        <span>
          {CustomerFirstName}
        </span>
        <div>
          <el-input
            v-model="internalVariableReplacements.customerFirstName"
            maxlength="100"
            placeholder="Enter customer first name..."
          />
        </div>
        <circle-arrow-icon />
      </div>
      <div v-if="hasCustomerLastName">
        <span>
          {CustomerLastName}
        </span>
        <div>
          <el-input
            v-model="internalVariableReplacements.customerLastName"
            maxlength="100"
            placeholder="Enter customer last name..."/>
        </div>
        <circle-arrow-icon />
      </div>
    </div>
    <template #footer>
      <span>
        <dd-button type="text" @click="closeModal">Cancel</dd-button>
        <dd-button
          v-if="createAnother"
          :is-disabled="!isSubmittable"
          size="large"
          type="flat"
          @click="submit"
        >Send &amp; add another
        </dd-button>
        <dd-button
          v-else
          :is-disabled="!isSubmittable"
          :color="ColorAssistant.MailboxColor"
          size="large"
          @click="submit"
        >Send conversation
        </dd-button>
      </span>
    </template>
  </dd-modal>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IConvosOutputReplyVariableReplacements } from '@/api/types/response.types'
import { IStatusMapping } from '@/api/types/request.types'

/* API */

export default defineComponent({
  name: 'ConfirmReplyVariablesModal',

  props: {
    createAnother: {
      type: Boolean,
      default: false,
    },
    hasCustomerName: {
      type: Boolean,
      default: false,
    },
    hasCustomerFirstName: {
      type: Boolean,
      default: false,
    },
    hasCustomerLastName: {
      type: Boolean,
      default: false,
    },
    variableReplacements: {
      type: Object as () => IConvosOutputReplyVariableReplacements,
      required: true,
    },
  },

  emits: ['confirm-canceled', 'send-clicked', 'update:variableReplacements'],

  data() {
    return {
      ColorAssistant,
      isSubmitting: false,
      statusMappings: [] as IStatusMapping[],
    }
  },

  computed: {
    internalVariableReplacements: {
      get(): IConvosOutputReplyVariableReplacements {
        return this.variableReplacements
      },
      set(value: IConvosOutputReplyVariableReplacements) {
        this.$emit('update:variableReplacements', value)
      },
    },
    isSubmittable(): boolean {
      if (this.hasCustomerName) {
        if (
          this.internalVariableReplacements.customerName === null ||
          this.internalVariableReplacements.customerName.trim().length === 0
        ) {
          return false
        }
      }

      if (this.hasCustomerFirstName) {
        if (
          this.internalVariableReplacements.customerFirstName === null ||
          this.internalVariableReplacements.customerFirstName.trim().length ===
            0
        ) {
          return false
        }
      }

      if (this.hasCustomerLastName) {
        if (
          this.internalVariableReplacements.customerLastName === null ||
          this.internalVariableReplacements.customerLastName.trim().length === 0
        ) {
          return false
        }
      }

      return true
    },
  },

  methods: {
    closeModal() {
      this.$emit('confirm-canceled')
    },
    submit() {
      this.$emit('send-clicked')
    },
  },
})
</script>

<style lang="scss">
.confirm-reply-variables-modal {
  &__table {
    display: flex;
    flex-direction: column;

    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      height: 50px;

      > span {
        text-align: center;
        background-color: var(--color-background-secondary);
        padding: 8px;
        border-radius: 8px;
        border: $border--solid-light;
      }

      > * {
        width: 45%;
      }

      .circle-arrow-icon {
        position: absolute;
        left: calc(50% - 12px);
        top: calc(50% - 12px);
      }
    }
  }
}
</style>
